export default "__VITE_ASSET__CMNqJ0$S__ 100w";